"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tryParseDate = void 0;
/**
 * Próbuje odczytać datę
 *
 * @export
 * @param {...any[]} values
 * @returns {(Date | undefined)}
 */
function tryParseDate(...values) {
    for (const value of values) {
        if (!value) {
            continue;
        }
        if (!isNaN(Date.parse(value))) {
            return new Date(value);
        }
    }
}
exports.tryParseDate = tryParseDate;
//# sourceMappingURL=tryParseDate.js.map